import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common'
import { MatTabsModule } from '@angular/material/tabs'
import { FormTabHeaderComponent } from "./form-tab-header.component";
import { MatButtonModule } from "@angular/material/button";

@NgModule({
  imports: [
    CommonModule,
    MatTabsModule,
    MatButtonModule
  ],
  declarations: [FormTabHeaderComponent],
  exports: [FormTabHeaderComponent]
})
export class FormTabHeaderModule {}